<template>
<action-bar>
    <slot></slot>
    <go-back-btn></go-back-btn>
</action-bar>
</template>

<script>
import actionBar from './action-bar'
import goBackBtn from './go-back-btn'

export default {
    components: {
        actionBar,
        goBackBtn,
    }
}
</script>

<style>

</style>